import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import PercentileBars from './PercentileBars';
import { formatDuration, formatNumber } from './formatters';

const colorForWaitP95 = (p95) => {
  if (p95 == null) return 'var(--text-tertiary)';
  if (p95 < 60) return '#10B981';
  if (p95 < 300) return '#F59E0B';
  return '#DC2626';
};

const HighlightKpi = ({ value, color, sub, label }) => (
  <Card className="metric-card h-100">
    <CardBody>
      <div style={{ fontSize: 11, color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: 0.4 }}>
        {label}
      </div>
      <div
        style={{
          fontSize: 28,
          fontWeight: 700,
          color,
          transition: 'color 350ms ease',
        }}
      >
        {value}
      </div>
      {sub && <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>{sub}</div>}
    </CardBody>
  </Card>
);

const QueueWaitSection = ({ data }) => {
  const { t } = useTranslation();
  const wait = data?.queue_wait_seconds || {};
  const totalP95 = Number(wait.total?.p95);

  return (
    <Card className="mb-4 h-100">
      <CardHeader className="d-flex justify-content-between align-items-center">
        <span>
          <i className="fas fa-hourglass-half me-2" style={{ color: '#8B5CF6' }} />
          {t('Espera en cola')}
        </span>
        <small style={{ color: 'var(--text-tertiary)', fontWeight: 400 }}>
          created_at → started_at · {t('objetivo p95')} &lt; 60s
        </small>
      </CardHeader>
      <CardBody>
        <Row className="g-3 mb-3">
          <Col xs="12" md="4">
            <HighlightKpi
              label="p95 total"
              value={isFinite(totalP95) ? formatDuration(totalP95) : '—'}
              color={colorForWaitP95(totalP95)}
              sub={`${formatNumber(wait.total?.count)} ${t('jobs medidos')}`}
            />
          </Col>
          <Col xs="12" md="4">
            <HighlightKpi
              label="p50 total"
              value={isFinite(wait.total?.p50) ? formatDuration(wait.total?.p50) : '—'}
              color="var(--text-primary)"
              sub={t('mediana de espera')}
            />
          </Col>
          <Col xs="12" md="4">
            <HighlightKpi
              label={t('máx total')}
              value={isFinite(wait.total?.max) ? formatDuration(wait.total?.max) : '—'}
              color="var(--text-primary)"
              sub={t('job más antiguo en la ventana')}
            />
          </Col>
        </Row>

        <PercentileBars
          groups={wait}
          metrics={['mean', 'p50', 'p95', 'p99']}
          logScale
          height={280}
        />

        <div
          style={{
            fontSize: 12,
            color: 'var(--text-tertiary)',
            marginTop: 8,
          }}
        >
          <i className="fas fa-info-circle me-1" />
          {t('Tiempo entre')} <code>created_at</code> {t('y')} <code>started_at</code>. {t('p95 alto = acumulación o backlog en arrastre. Se usa escala logarítmica porque los rangos típicos van de segundos a horas (varios órdenes de magnitud).')}
        </div>
      </CardBody>
    </Card>
  );
};

export default QueueWaitSection;
